<div class="flex w-full h-screen ">
  <div class="flex flex-col w-full h-screen gap-8 space-y-4">
    <div class="mx-auto mt-8">
      <!-- Logo -->
      <div class="flex flex-col items-center justify-center gap-4">
        <img src="/logo.png" alt="Smarcel Logo" class="h-20 w-auto" />
      </div>
    </div>
    <mat-card class="mx-auto mb-auto max-w-[400px]">
      <mat-card-content>
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
          <!-- Title -->
          <div class="mt-8 text-2xl font-extrabold tracking-tight leading-tight text-center"
            transloco="AUTH.LOGOUT.TITLE"></div>
          <div class="flex justify-center mt-4 font-medium">
            <!-- Redirect countdown -->
            @if (countdown > 0) {
            {{ 'AUTH.LOGOUT.REDIRECTING_IN' | transloco: {
            seconds: (countdown | i18nPlural: countdownMapping)
            } }}
            }

            <!-- Redirect message -->
            @if (countdown === 0) {
            <p transloco="AUTH.LOGOUT.REDIRECTING"></p>
            }
          </div>

          <!-- Form footer -->
          <div class="mt-8 text-md font-medium text-tertiary text-center">
            <span transloco="AUTH.LOGOUT.GO_TO"></span>
            <a class="ml-1 text-primary-500 hover:underline" [routerLink]="['/sign-in']" transloco="AUTH.LOGOUT.SIGN_IN">
            </a>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
